export const PATHS = {
  homePath: () => `/`,
  loginPath: () => `/login`,
  resetPasswordPath: (token: string) => `/reset-password/${token}`,
  errorPath: (code: string) => `/${code}`,

  reportsPath: () => `/reports`,
  newReportPath: () => `/new-report`,
  reportPath: (id: string) => `/report/${id}`,

  projectsPath: () => `/projects`,
  newProjectPath: () => `/new-project`,
  projectPath: (id: string) => `/project/${id}`,

  newUserPath: () => `/user/new`,
  profilePath: () => `/profile`,
  settingsPath: () => `/user/settings`,

  userPath: (id: string) => `/user/${id}`,
  usersPath: () => `/users`,
};
